import {
  GroupWithStudentsAndModulesResponseApi,
  isGroupResponseDTO,
} from "../Group/Group";
import { isStudentResponseDTO, StudentResponseApi } from "./Student";

export interface StudentWithGroupsResponseApi extends StudentResponseApi {
  studentGroups: GroupWithStudentsAndModulesResponseApi[];
}

export let isStudentWithGroupsResponseDTO = (
  variable: unknown
): variable is StudentWithGroupsResponseApi => {
  return (
    isStudentResponseDTO(variable) &&
    "studentGroups" in variable &&
    Array.isArray(variable.studentGroups) &&
    variable.studentGroups.reduce(
      (doArrayConsistOfGroups, studentGroup) =>
        doArrayConsistOfGroups && isGroupResponseDTO(studentGroup)
    )
  );
};
